module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.2c174adc.woff";